module.exports = __webpack_public_path__ + "static/img/product-features.87fca2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/product-features.png
// module id = n8OO
// module chunks = 1